import { render } from "./HeroActions.vue?vue&type=template&id=ab0c3af0&scoped=true"
import script from "./HeroActions.vue?vue&type=script&lang=js"
export * from "./HeroActions.vue?vue&type=script&lang=js"

import "./HeroActions.vue?vue&type=style&index=0&id=ab0c3af0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab0c3af0"]])

export default __exports__